/**
 * Eyebrow + title + optional lede for public marketing sections (extracted from
 * HomePage at #3125, its second consumer). Club-blue eyebrow, `text-section`
 * title — the #3122 anchor's token spend. Output is byte-identical to the
 * original front-door component.
 */
export default function SectionHead({
  eyebrow,
  title,
  lede,
}: {
  eyebrow: string;
  title: string;
  lede?: string;
}) {
  return (
    <>
      <span className="block text-xs font-semibold uppercase tracking-widest text-oro-club">
        {eyebrow}
      </span>
      <h2 className="mt-3 text-section font-bold leading-tight tracking-tight text-text-primary">
        {title}
      </h2>
      {lede && <p className="mt-4 max-w-xl text-base text-text-secondary">{lede}</p>}
    </>
  );
}
